import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { fetchVideoDetail, createVideo, updateVideo } from 'actions/Video'
import FormVideoView from 'components/pages/video/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchVideoDetail: bindActionCreators(fetchVideoDetail, dispatch),
  createVideo: bindActionCreators(createVideo, dispatch),
  updateVideo: bindActionCreators(updateVideo, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withState('imgFile', 'setImgFile', ''),
  withState('currentImg', 'setCurrentImg', ''),
  withState('data', 'setData', {}),
  withHandlers({
    getDetail: props => async (id) => {
      const {
        setData, setImgFile, setCurrentImg,
      } = props

      try {
        const res = await props.fetchVideoDetail(id)
        setData(res)
        setImgFile(res.thumbnail)
        setCurrentImg(res.thumbnail)
      } catch (err) {
        setData()
        setImgFile()
      }
    },
    handleUpload: props => (info) => {
      const isImage = Helper.checkingFile(info)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (isImage && fileList.length > 0) {
        const base64 = Helper.getBase64(info.file, file => props.setImgFile(file))
        return base64
      }
      return false
    },
    handleSubmit: props => (values) => {
      let payload

      props.setIsSubmit(true)
      if (props.imgFile === props.currentImg) {
        payload = {
          ...values,
        }
        delete payload.thumbnail
      } else {
        payload = {
          ...values,
          thumbnail: props.imgFile,
        }
      }

      if (props.isEdit) {
        props.updateVideo(props.match.params.id, payload)
          .then(() => {
            message.success('Video has been updated')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/video')
          })
          .catch(() => {
            props.setIsSubmit(false)
          })
      } else {
        props.createVideo(payload)
          .then(() => {
            message.success('Video has been created')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/video')
          })
          .catch(() => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const { match, setIsEdit, getDetail } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Video Form',
        activePage: 'video',
        activeSubPage: 'video',
      })
      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormVideoView)
